import { DateTime } from 'luxon';
import { IOrderTaskData } from 'types/tasks';

export const sortUndefined = <T>(a: T | undefined, b: T | undefined, action: (a: T, b: T) => number) => {
  if (a === undefined && b !== undefined) return -1;
  if (a !== undefined && b === undefined) return 1;
  if (a === undefined && b === undefined) return 0;
  // These two are never true, but typescript can't see that the above 3 lines do it.
  if (a === undefined) return 0;
  if (b === undefined) return 0;

  return action(a, b);
};

export const sortTasksBy =
  (
    column: 'dueDate' | 'assignedTo' | 'role' | 'taskName',
    direction: 'ascending' | 'descending' | 'none',
    userFilter: 'Mine' | 'All' | 'Completed'
  ) =>
  (taskA: IOrderTaskData, taskB: IOrderTaskData) => {
    if (direction === 'none') {
      return 0;
    }
    let smaller: number = 0;

    const dateA = userFilter === 'Completed' ? taskA.completedAt : taskA.dueDate;
    const dateB = userFilter === 'Completed' ? taskB.completedAt : taskB.dueDate;
    const nameA = userFilter === 'Completed' ? taskA.completedBy?.fullName : taskA.teammate?.fullName;
    const nameB = userFilter === 'Completed' ? taskB.completedBy?.fullName : taskB.teammate?.fullName;

    switch (column) {
      case 'dueDate':
        smaller = sortUndefined(dateA, dateB, (a, b) => {
          return DateTime.fromISO(a).diff(DateTime.fromISO(b)).milliseconds;
        });
        break;
      case 'assignedTo':
        smaller = sortUndefined(nameA, nameB, (a, b) => {
          return a.localeCompare(b);
        });
        break;
      case 'role':
        smaller = sortUndefined(taskA.role, taskB.role, (a, b) => {
          return a.localeCompare(b);
        });
        break;
      case 'taskName':
        smaller = sortUndefined(taskA.description, taskB.description, (a, b) => {
          return a.localeCompare(b);
        });
        break;
      default:
        return 0;
    }
    if (direction === 'ascending') {
      return smaller;
    } else {
      return -smaller;
    }
  };
